import React from 'react';
import ContentSection from '../ContentSection';
// @ts-expect-error ts-migrate(2306) FIXME: File '/mnt/c/Users/Mark/PhpstormProjects/kmbooking... Remove this comment to see the full error message
import icons from '../../../markons/markons';
import css from './insights.less';
import BillYearMonthData from './BillYearMonthData';


const iconMap = {
    'same': icons.ionMinusRound,
    'up': icons.ionArrowUpB,
    'down': icons.ionArrowDownB,
};

type State = any;

export default class BillYearMonth extends React.PureComponent<{}, State> {

    state = {year: (new Date).getFullYear()};


    changeYear = (val: any) => {
        // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'year' implicitly has an 'any' typ... Remove this comment to see the full error message
        this.setState(({year}) => ({year: year + val}));
    };

    render() {

        return (
            <ContentSection title="Year-Over-Year Growth" storageKey="reports-insights-bill-year-month"
                            className="no-scroll">
                {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'year' does not exist on type 'IntrinsicA... Remove this comment to see the full error message */}
                <BillYearMonthData year={this.state.year} changeYear={this.changeYear}/>
                <p className={css.reportHelpText}>Billing totals grouped by year+month of first pickup compared to same
                    month of previous year.</p>
            </ContentSection>
        )
    }
}
